<template>
  <div class="main row">
    <div class="content-container row">
      <img class="img" src="../assets/img/logo.svg">
      <span v-if="authSuccess" >正在跳转到香侬舆情...</span>
      <div v-else class="red">用户信息验证失败</div>
    </div>
  </div>
</template>

<script>
import localStorageHelper from '@/helpers/localStorageHelper';
import { 
  AUTH_TOKEN_KEY, 
  USER_NAME, 
  PHONE_NUMBER, 
  AUTH_TOKEN_TYPE 
} from '@/helpers/constants';

export default {
  data() {
    return {
      authSuccess: true
    };
  },
  methods: {
    handleUrl() {
      const token = this.$route.query.authtoken;
      const type = this.$route.query.type;
      const phone = this.$route.query.phone;
      if (!token || !type || !phone) {
        this.$message.error('URL错误，请检查URL格式是否正确');
        this.authSuccess = false;
        setTimeout(() => {
          const a = document.createElement('a');
          // a.setAttribute('href', 'http://localhost:8080/#/new-login');
          // a.setAttribute('href', 'http://10.20.31.205:8018/#/new-login');
          a.setAttribute('href', 'http://inews-cicc.shannonai.com/#/new-login');
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }, 2000); 
      } else {
        localStorageHelper.setItem(AUTH_TOKEN_KEY, token);
        localStorageHelper.setItem(AUTH_TOKEN_TYPE, type);
        localStorageHelper.setItem(USER_NAME, phone);
        localStorageHelper.setItem(PHONE_NUMBER, phone);
        this.$router.push({
          path: '/'
        });
      }
    }
  },
  watch: {
    $route() {
      this.handleUrl();
    }
  },
  mounted() {
    this.handleUrl();
  }
};
</script>

<style lang="scss" scoped>
  .main {
    justify-content: center;
    width: 100%;
    height: 100%;
    .content-container {
      flex-direction: column;
      margin-top: 20%;
      .img {
        margin-bottom: 24px;
      }
      .red {
        color: #eb0f0f;
      }
    }
  }
</style>
